// The internal/audit database has a fixed ID across all Metabase instances.
export const AUDIT_DB_ID = 13371337;

// View names in the audit database for metabot analytics.
export const VIEW_CONVERSATIONS = "v_metabot_conversations";
export const VIEW_MESSAGES = "v_metabot_messages";
export const VIEW_USAGE_LOG = "v_ai_usage_log";
export const VIEW_GROUP_MEMBERS = "v_group_members";
